import { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

const usePostcodeOOA = (postCode, country) => {
	const [outofAreaPostcode, setOutofAreaPostcode] = useState(false);

	useEffect(() => {
		if (
			country === 'AU' &&
			postCode &&
			((postCode >= '0800' && postCode <= '0821') ||
				(postCode >= '0828' && postCode <= '0851') ||
				(postCode >= '0860' && postCode <= '0861') ||
				(postCode >= '0870' && postCode <= '0871') ||
				(postCode >= '0887' && postCode <= '0999') ||
				(postCode >= '0822' && postCode <= '0827') ||
				(postCode >= '0854' && postCode <= '0859') ||
				(postCode >= '0862' && postCode <= '0869') ||
				(postCode >= '0872' && postCode <= '0886') ||
				(postCode >= '6215' && postCode <= '6699') ||
				(postCode >= '6700' && postCode <= '6797') ||
				(postCode >= '6798' && postCode <= '6799') ||
				postCode == '0853' ||
				postCode == '0852' ||
				postCode == '2899' ||
				postCode == '7151')
		) {
			setOutofAreaPostcode(true);
		} else {
			setOutofAreaPostcode(false);
		}
	}, [postCode]);

	return outofAreaPostcode;
};

usePostcodeOOA.PropTypes = {
	/**
	 * Email address to pass to API
	 */
	postCode: PropTypes.string,
	country: PropTypes.string,
};

export default usePostcodeOOA;
